import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";

const path = `${baseUrl}/constants/`;

export const useAllConstants = () => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    queryKey: [`all_constants`],
    queryFn: () => {
      return appAxios.get(`${path}`).then((res) => res.data);
    },
    cacheTime: 3600000,
    staleTime: 3600000,
  });
};

export const useAllBackofficeConstants = () => {
  const { appAxiosRingback } = useContext(AuthenticationContext);

  return useQuery({
    queryKey: [`all_backoffice_constants`],
    queryFn: () => {
      return appAxiosRingback.get(`${path}`).then((res) => res.data);
    },
    cacheTime: 3600000,
    staleTime: 3600000,
    retry: false,
  });
};

export default { useAllConstants, useAllBackofficeConstants };
